import { loadStripe } from '@stripe/stripe-js';

// Lazy load Stripe only when needed (on-demand loading)
let stripePromise = null;

const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

export async function redirectToCheckout(userEmail, plan = 'pro') {
  try {
    // Create checkout session via backend
    const response = await fetch('/.netlify/functions/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: userEmail, plan }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to create checkout session');
    }

    // Load Stripe only when user initiates checkout
    const stripe = await getStripe();
    const { error } = await stripe.redirectToCheckout({
      sessionId: data.sessionId,
    });

    if (error) {
      console.error('Stripe redirect error:', error);
      throw error;
    }
  } catch (error) {
    console.error('Checkout error:', error);
    throw error;
  }
}

export async function upgradeSubscription(userEmail, newPlan) {
  try {
    const response = await fetch('/.netlify/functions/upgrade-subscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: userEmail, newPlan }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to upgrade subscription');
    }

    return data;
  } catch (error) {
    console.error('Upgrade error:', error);
    throw error;
  }
}